import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import SupportAcoustic from "../components/SupportAcoustic";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportAcoustic);
const withTranslationComponent = withTranslation(["supportAcoustic", "support", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/SupportAcoustic.js